import { TableProject } from "modules/projects/types";

export const getProjectRegion = (
  projects: TableProject[],
  projectId: string
): string | undefined =>
  projects.find((project) => project.id === projectId)?.region.toLowerCase();
